/**
 * Запит пошуку записів за кодом: «TSK-3», «tsk 3» або «#3» → «3» (API списку шукає номер без префікса типу); інший текст — як є, без
 * пробілів по краях.
 */
export function codeQuery(query: string, prefix: string | undefined): string {
  const q = query.trim();
  if (!q) return '';
  const p = (prefix ?? '').trim();
  const m = (p && new RegExp(`^${p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}[\\s-]*(\\d+)$`, 'i').exec(q)) || /^#(\d+)$/.exec(q);
  return m ? m[1]! : q;
}
